/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Mfa_Method_Password_DescriptionInputs */

const de_auth_mfa_method_password_description = /** @type {(inputs: Auth_Mfa_Method_Password_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit Passwort fortfahren`)
};

/** @type {(inputs: Auth_Mfa_Method_Password_DescriptionInputs) => LocalizedString} */
const en_auth_mfa_method_password_description = de_auth_mfa_method_password_description;

/**

* @param {Auth_Mfa_Method_Password_DescriptionInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_mfa_method_password_description = /** @type {((inputs?: Auth_Mfa_Method_Password_DescriptionInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Mfa_Method_Password_DescriptionInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_mfa_method_password_description(inputs)
	return en_auth_mfa_method_password_description(inputs)
});